import "../styles/contactContainer.css"
import ContactoComponent from "../components/contact-component/ContactComponent";

const Contacto = () => {
    return (
        <>
            <ContactoComponent/>
        </>
    )
}

export default Contacto;
